export const SET_TOKEN_RECAPTCHA = 'TBEXTERNO_REDESIM_SET_TOKEN_RECAPTCHA';
export const SET_TOKEN_RECAPTCHA_MODAL = 'TBEXTERNO_REDESIM_SET_TOKEN_RECAPTCHA_MODAL';
export const TOGGLE_MODAL_IMPRIMIR_SOLICITACAO = 'TBEXTERNO_REDESIM_TOGGLE_MODAL_IMPRIMIR_SOLICITACAO';
export const PESQUISAR_IMPRIMIR_SOLICITACAO_MODAL = 'TBEXTERNO_PESQUISAR_IMPRIMIR_SOLICITACAO_MODAL';
export const PESQUISAR_IMPRIMIR_SOLICITACAO = 'TBEXTERNO_PESQUISAR_IMPRIMIR_SOLICITACAO';
export const ABRIR_IMPRIMIR_SOLICITACAO = 'TBEXTERNO_ABRIR_IMPRIMIR_SOLICITACAO';
export const SET_GRID_PESQUISA_IMPRIMIR_SOLICITACAO = 'TBEXTERNO_SET_GRID_PESQUISA_IMPRIMIR_SOLICITACAO';
export const LIMPA_GRIDS_IMPRIMIR_SOLICITACAO = 'TBEXTERNO_LIMPA_GRIDS_IMPRIMIR_SOLICITACAO';
export const SET_RECAPTCHA_RESET_REF = 'TBEXTERNO_SET_RECAPTCHA_RESET_REF';
export const SET_RECAPTCHA_RESET_REF_MODAL = 'TBEXTERNO_SET_RECAPTCHA_RESET_REF_MODAL';
